import { ContainerTopProduct, ImageDivider, CustomText } from '@vfit/shared/atoms';
import { Fade } from 'react-awesome-reveal';
import { purify } from '@vfit/shared/themes';
import React from 'react';
import { IFreeHtml } from './freeHtml.models';
import { DisclaimerContainer } from './freeHtml.style';
import { useDeviceType } from '@vfit/shared/hooks';

const FreeHtml = ({ html, htmlMobile, divider, disclaimer, title }: IFreeHtml) => {
  const { isMobile } = useDeviceType();
  const [pHtmlDesktop, pHtmlMobile] = purify([html, htmlMobile || html]);
  const htmlToDisplay = isMobile ? pHtmlMobile || pHtmlDesktop : pHtmlDesktop;

  return (
    <>
      {title && (
        <CustomText text={title} size={36} lineHeight={50} sizeMobile={30} lineHeightMobile={38} />
      )}
      {htmlToDisplay && (
        <ContainerTopProduct
          haveTitle={!!title}
          dangerouslySetInnerHTML={{ __html: htmlToDisplay }}
        />
      )}
      {disclaimer && (
        <DisclaimerContainer>
          <CustomText text={disclaimer} lineHeight={22} size={16} textAlign="left" />
        </DisclaimerContainer>
      )}
      {divider?.image && (
        <Fade direction="up" triggerOnce>
          <ImageDivider image={divider?.image} alt={divider.text || ''} />
        </Fade>
      )}
    </>
  );
};

export default FreeHtml;

